import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1
  },
  title: {
    color: theme.palette.text.primary
  },
  username: {
    color: theme.palette.text.primary,
    marginRight: 25
  },
  sectionIcons: {
    display: 'flex'
  },
  accountAction: {
    borderRadius: 10
  },
  avatar: {
    height: 40,
    width: 40,
    textTransform: 'uppercase'
  },
  actionContainer: {
    position: 'relative'
  },
  newAdviceButton: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    border: '2px solid rgba(119, 0, 210, 0.2)',
    padding: '8px 43px',
    marginBottom: 0
  },
  secondaryMobile: {
    marginTop: '0!important',
    '& .MuiToolbar-regular': {
      marginTop: '56px!important',
      height: 72
    }
  },
  mobileAppBar: {
    boxShadow: 'none',
    zIndex: 5,
    backgroundColor: '#262626',
    height: 56
  },
  mobileToolbar: {
    minHeight: 56,
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    color: '#FFF'
  },
  menuButton: {
    marginRight: 32
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  logoWrapperImage: {
    width: 32,
    height: 32,
    marginRight: 3
  },
  logoWrapperText: {
    height: 14.5,
    width: 70
  },
  searchIcon: {
    fill: '#FFF'
  },
  bellButton: {
    marginLeft: 24
  },
  drawerPaper: {
    padding: '42px 25px',
    width: '100%',
    maxWidth: 560
  },
  notificationsTitle: {
    marginBottom: 29,
    display: 'flex',
    justifyContent: 'space-between'
  },
  closeButton: {
    padding: 0
  }
}))

export default useStyles
